import { allModelsSelector } from 'common-src/utils/selectorUtils';

import DashboardV2Readiness from './DashboardV2Readiness';

export const getDashboardV2ReadinessRows = (state) =>
  allModelsSelector(state, DashboardV2Readiness.modelName).sort(
    (a, b) => new Date(b?.computedAt || 0) - new Date(a?.computedAt || 0),
  );
